import * as React from 'react';
import wrapDisplayName from 'react-wrap-display-name';
import hoistStatics from 'hoist-non-react-statics';
import I18n from '../../components/I18n';

var translate = function translate(namespaces) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (WrappedComponent) {
    var TranslateInner = function TranslateInner(props, ref) {
      return React.createElement(I18n, {
        ns: namespaces,
        options: options
      }, function (__) {
        return React.createElement(WrappedComponent, Object.assign({}, props, {
          __: __,
          ref: ref
        }));
      });
    };

    TranslateInner.displayName = wrapDisplayName(WrappedComponent, 'Translate');
    var Translate = React.forwardRef(TranslateInner);
    Translate.WrappedComponent = WrappedComponent;
    return hoistStatics(Translate, WrappedComponent);
  };
};

translate.legacy = require('./legacy').default;
export default translate;